import { render, staticRenderFns } from "./AvgInspectionScoreCharts.vue?vue&type=template&id=13cabf4c&scoped=true"
import script from "./AvgInspectionScoreCharts.vue?vue&type=script&lang=js"
export * from "./AvgInspectionScoreCharts.vue?vue&type=script&lang=js"
import style0 from "./AvgInspectionScoreCharts.vue?vue&type=style&index=0&id=13cabf4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cabf4c",
  null
  
)

export default component.exports